<template>
  <div class="organizationUpsertForm">
    <div class="modal-header">
      <upload field-name="Image" style="width: 100%;" v-model="formData.logoId" :image="formData.logo" />
    </div>
    <div class="input-group">
      <h3>{{ organization ? 'Edit' : 'Add' }} organization</h3>
      <dg-input type="text" v-model="formData.name" placeholder="Name" :disabled="!$auth.user.isSystem"/>
      <dg-input type="text" v-model="formData.email" placeholder="E-mail"/>
      <dg-input type="text" v-model="formData.phoneNumber" placeholder="Phone"/>
      <dg-input type="text" v-model="formData.address" placeholder="Address"/>
      <div class="input-grouped">
        <dg-input type="text" v-model="formData.city" placeholder="City"/>
        <dg-input type="text" v-model="formData.zip" placeholder="Zip"/>
      </div>
      <div class="split">
        <picker
          placeholder="Country"
          :api="$api.country().index"
          value-key="id"
          @pick="getCountryCurrency"
          v-model="formData.countryId" />
        <picker
          v-if="formData.countryId !== ''"
          placeholder="Organization currency"
          :api="$api.currencies.index"
          value-key="id"
          v-model="formData.currencyId" />
      </div>
      <el-dialog :append-to-body="true" title="Pricing" :visible.sync="showPricingDialog" width="450px">
        <pricing-form @create="setFees" :accountNumber="formData.accountNumber" :monthly="formData.monthlyFee" :fee="formData.transactionFee" />
      </el-dialog>
      <el-button type="primary" icon="el-icon-arrow-right" @click="showPricingDialog = true">Proceed</el-button>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/shared/Uploader'
import Picker from '@/components/shared/CollectionPicker'
import PricingForm from './PricingForm'

export default {
  name: 'OrganizationUpsertForm',
  components: { Upload, Picker, PricingForm },
  props: {
    organization: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      showPricingDialog: false,
      formData: {
        name: '',
        email: '',
        logoId: '',
        logo: null,
        country: null,
        countryId: '',
        currencyId: null,
        address: '',
        zip: '',
        city: '',
        phoneNumber: '',
        monthlyFee: null,
        transactionFee: null,
        accountNumber: null,
        registrationNumber: null,
        IBAN: null,
        bankName: null
      }
    }
  },
  methods: {
    setFees (data) {
      this.formData.monthlyFee = data.monthlyFee
      this.formData.transactionFee = data.transactionFee

      this.handleClick()
    },
    getCountryCurrency (country) {
      this.formData.currencyId = country.currency.id
    },
    handleClick () {
      if (this.organization) {
        this.update().catch(error => this.$message.error('Organization could not be updated, try again.'))
      } else {
        this.add().catch(error => this.$message.error('Organization could not be created, try again.'))
      }
    },
    async update () {
      const response = await this.$http.put(this.$api.organizations.update(this.organization.id), this.formData)
      this.$message.success('Organization updated successfully')
      this.$emit('updated', response.data)
    },
    async add () {
      const response = await this.$http.post(this.$api.organizations.create, this.formData)
      this.$message.success('Organization created successfully')
      this.$emit('created', response.data)
    }
  },
  created () {
    if (this.organization) {
      this.formData.logoId = this.organization.logo ? this.organization.logo.id : null
      this.formData.countryId = this.organization.country.id
      this.formData.currencyId = this.organization.currency.id

      let currentPricingModel = this.organization.pricingModels.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })[0]
      
      this.formData.monthlyFee = currentPricingModel.monthlyFee
      this.formData.transactionFee = currentPricingModel.transactionFee

      for (const key in this.organization) {
        this.formData[key] = this.organization[key]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .split {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      flex: 1;
    }
  }

  .modal-header {
    background-color: #008fcc;
    padding: 20px 20px;
  }

  .input-group {
    padding: 15px 20px 20px 20px;

    h3 {
      margin-top: 5px;
      margin-bottom: 20px;
      font-size: 14px;
      text-transform: none;
    }

    p {
      text-align: left;
      font-size: 12px;
      margin: 0px;
      color: #909399;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/UpsertForm.vue